import React from "react";
import Shared02Headings from "../../../guestsharedcomponents/Shared02Headings/Shared02Headings";

const FooterMainInfo = () => {
  return (
    <div className="main-info">
      <Shared02Headings
        options={{
          style_render: "992",
          main_container_css: "",
          container_mobile_styles: {
            "margin-bottom": "6rem",
          },
          container_desktop_styles: {
            "max-width": "45rem",
          },
          obj_heading: {
            main_text:
              "Ready to <span class='t-enlace'>Learn Bachata</span> With Confidence?",
            main_tag_version: "h2",
            main_text_css: "t-h-2",
            heading_mobile_styles: {
              color: "#fff",
              "text-align": "center",
              "font-weight": "900",
              "margin-bottom": "0.5rem",
              "text-shadow":
                "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
            },
            heading_desktop_styles: {
              "text-align": "left",
            },
          },
          obj_support_heading: false,

          obj_divider: {
            divider_mobile_styles: {
              width: "70%",
              background:
                "linear-gradient(90deg, transparent, #e6c28b, transparent)",
              margin: "0 auto 4rem auto",
            },
            divider_desktop_styles: {
              width: "60%",
              background:
                "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
              margin: "0 0 3rem 0",
            },
          },
          obj_paragraph: false,
          obj_buttons: {
            main_objinfo: {
              icon_left: false,
              icon_right: false,
              main_btn_heading: "Start Learning",
              main_btn_link: "https://members.ltmastery.com/",
              main_btn_container_classes: "t-btn-principal-1 t-mb-1 t-mr-1",
              main_btn_classes: "t-uppercase t-font-1-4",
              main_btn_version: "external_link_button", //main_button, internal_link_button, external_link_button
              main_btn_loader: false,
              main_handleClick: false,
            },
            secundary_objinfo: false,
            btn_main_container_classes: "",
          },
          heading_version: "heading_01",
        }}
      />
    </div>
  );
};

export default FooterMainInfo;
